package org.example.zone360.pages.widgets.spiderChartModal

import SpiderChartForDashboard
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import org.example.zone360.components.widgetTitleFontSize
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.models.WidgetTrend
import org.example.zone360.pages.dashboard.chart.MiniBars
import org.example.zone360.pages.widgets.helper.WidgetTooltipIcon
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.CheckboxInput
import org.w3c.dom.HTMLInputElement

@Composable
fun SpiderChartWidgetCard(
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    labels: List<String>,
    values: List<Int>,
    chartColor: String,
    score: Int,
    clubAvg: Int,
    modifier: Modifier = Modifier,
    isCoachPage: Boolean = false,
    sessionBorder: Boolean = false,
    showSelection: Boolean = false,
    forceFullWidth: Boolean = false,
    sessionBorderWidth: Int = 220,
    trendData: List<WidgetTrend> = emptyList(),
    isSelected: Boolean = false,
    onSelectionChange: ((Boolean) -> Unit)? = null,
    tooltipText: String = "",
    tooltipTitle: String = "",
    chartRightMargin: Int = 0
) {
    var widgetDetailResponse by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var showModal by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    Box(
        modifier = modifier
            .then(
                when {
                    forceFullWidth -> Modifier.fillMaxWidth()   // ✅ session detail
                    sessionBorder -> Modifier.fillMaxWidth()    // ✅ session border card
                    else -> Modifier.minWidth(                  // ✅ normal dashboard
                        when {
                            breakpoint < Breakpoint.MD -> 320.px
                            showSelection -> 280.px
                            window.screen.width in 1200..1500 -> 318.px
                            else -> 350.px
                        }
                    )
                }
            )
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(if (showSelection) 12.px else 16.px)
            .padding(if (showSelection) 12.px else if (sessionBorder) 15.px else 20.px)
            .border(
                if (showSelection) 2.px else if (sessionBorder) 1.px else 0.px,
                LineStyle.Solid,
                Color.rgb(220, 220, 220)
            )
            .then(
                when {
                    breakpoint < Breakpoint.MD -> Modifier
                    sessionBorder -> Modifier.height(285.px)
                    !showSelection -> Modifier.height(380.px)
                    else -> Modifier
                }
            )
            .styleModifier {
                property("position", "relative")
            }
    ) {
        if (showSelection) {
            Box(
                modifier = Modifier
                    .styleModifier {
                        property("position", "absolute")
                        property("top", "9px")
                        property("right", "9px")
                        property("cursor", "pointer")
                    }
                    .zIndex(9999)
            ) {

                CheckboxInput(
                    checked = isSelected
                ) {
                    onChange { event ->
                        onSelectionChange?.invoke(
                            (event.target as HTMLInputElement).checked
                        )
                    }

                    style {
                        property("transform", "scale(1.4)")
                        property("cursor", "pointer")
                    }
                }
            }
        }
        Column(modifier = Modifier.fillMaxWidth().then(
            if (breakpoint < Breakpoint.MD) Modifier
            else Modifier.height(if (showSelection) 350.px else 340.px)
        )) {
            // Header
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth().margin(bottom = 8.px)
            ) {
                Box(
                    modifier = Modifier
                        .width(if (sessionBorder) 24.px else 28.px)
                        .height(if (sessionBorder) 24.px else 28.px)
                        .backgroundColor(widgetColor)
                        .borderRadius(6.px)
                        .margin(right = 10.px),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = widgetNo.toString(),
                        fontSize = 14.px,
                        fontWeight = 700,
                        color = sitePalette.bodyBackgroundSecondary.rgb
                    )
                }
                FieldTitleTextNormalSimple(
                    text = widgetName,
                    fontSize = widgetTitleFontSize(showSelection, sessionBorder, breakpoint),
                    fontWeight = 700
                )
                if (!showSelection) {
                    Box(modifier = Modifier.weight(1f))
                }
                if (tooltipText.isNotEmpty()) {
                    WidgetTooltipIcon(
                        tooltipTitle = tooltipTitle,
                        tooltipText = tooltipText,
                        modifier = Modifier.margin(left = if (showSelection) 4.px else 8.px)
                    )
                }
            }

            val actualSpiderId =
                if (showSelection)
                    "spider_widget_${widgetNo}_popup"
                else
                    "spider_widget_${widgetNo}"
            // Spider Chart
            SpiderChartForDashboard(
                chartId = actualSpiderId,
                labels = labels,
                values = values,
                color = chartColor,
                sessionBorder = sessionBorder,
                score = score,
                clubAvg = clubAvg,
                chartHeight = if (showSelection) 210 else 180,
                showScore = true,
                sessionBorderWidth = sessionBorderWidth,
                fillOpacity = 0.25,
                maxValue = 100,
                isCoachPage = isCoachPage,
                showSelection = showSelection,
                marginRight = chartRightMargin
            )

            Spacer()
            // View Details Button
            if (!sessionBorder) {
                if (isCoachPage) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = if (showSelection) 4.px else 0.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .cursor(Cursor.Pointer)
                                .margin(top = 4.px)
                        ) {
                            MiniBars(
                                color = widgetColor,
                                trends = trendData
                            )
                        }
                    }

                } else {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(42.px)
                            .margin(top = 8.px)
                            .backgroundColor(Palette.ViewDetailBackground.rgbLight)
                            .borderRadius(8.px)
                            .border(
                                1.px,
                                LineStyle.Solid,
                                color = Palette.ViewDetailBorder.rgbLight
                            )
                            .cursor(Cursor.Pointer)
                            .onClick {
                                showModal = true
                            }
                    ) {
                        Box(
                            modifier = Modifier.fillMaxSize(),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "View Details",
                                fontSize = 14.px,
                                fontWeight = 600,
                                color = Palette.ViewDetailText.rgbLight
                            )
                        }
                        Box(
                            modifier = Modifier
                                .fillMaxHeight()
                                .fillMaxWidth()
                                .padding(right = 12.px),
                            contentAlignment = Alignment.CenterEnd
                        ) {
                            FaAngleRight(
                                modifier = Modifier
                                    .width(12.px)
                                    .height(12.px)
                                    .color(Palette.ViewDetailAngle.rgbLight)
                            )
                        }
                    }
                }
            }
        }
    }
    if (showModal) {
        SpiderChartDetailsModal(
            widgetNo = widgetNo,
            widgetName = widgetName,
            widgetColor = widgetColor,
            labels = labels,
            values = values,
            chartColor = chartColor,
            score = score,
            clubAvg = clubAvg,
            widgetKey = "game_realism",
            coaches = null,         // pass WidgetDetailResponse from parent
            isCoachPage = isCoachPage,
            onClose = { showModal = false }
        )
    }
}